if (!customElements.get('delivery-estimate-cc')) {
  customElements.define(
    'delivery-estimate-cc',
    class DeliveryEstimateCC extends HTMLElement {
      connectedCallback() {
        this.dateElement = this.querySelector('[data-delivery-date-cc]');
        if (!this.dateElement) return;

        this.update();
        this.scheduleNextUpdate();
      }

      disconnectedCallback() {
        window.clearTimeout(this.updateTimer);
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let remainingDays = days;

        while (remainingDays > 0) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) remainingDays -= 1;
        }

        return result;
      }

      update() {
        const businessDays = Math.max(Number.parseInt(this.dataset.businessDays, 10) || 3, 1);
        const date = this.addBusinessDays(new Date(), businessDays);
        const localDate = [
          date.getFullYear(),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0'),
        ].join('-');

        this.dateElement.dateTime = localDate;
        this.dateElement.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        }).format(date);
      }

      scheduleNextUpdate() {
        const now = new Date();
        const nextMidnight = new Date(now);
        nextMidnight.setHours(24, 0, 1, 0);

        this.updateTimer = window.setTimeout(() => {
          this.update();
          this.scheduleNextUpdate();
        }, nextMidnight.getTime() - now.getTime());
      }
    }
  );
}
